import CryptoJS from "crypto-js";

const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY || process.env.ENCRYPTION_KEY || 'codedestate';

// Utility function for consistent number formatting
export const formatPrice = (price) => {
  if (!price || isNaN(price)) return "0";
  
  // Format with commas for thousands separator
  return Math.round(price).toLocaleString('en-US');
};

// Encrypt data for backend
const encryptData = (data) => {
  try {
    console.log('Encrypting data with key:', ENCRYPTION_KEY.substring(0, 10) + '...');
    console.log('Data to encrypt:', data);
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      ENCRYPTION_KEY
    ).toString();
    console.log('Encryption successful, length:', encrypted.length);
    return encrypted;
  } catch (error) {
    console.error('Encryption error:', error);
    return JSON.stringify(data);
  }
};

// API function with proper encryption and fallback
const apiCall = async (endpoint, params = {}) => {
  try {
    console.log('Making API call to:', endpoint, 'with params:', params);
    console.log('Backend server URL:', process.env.REACT_APP_BACKEND_SERVER);
    
    const encryptedPayload = encryptData(params);
    
    const requestBody = { payload: encryptedPayload };
    console.log('Request body structure:', { payload: 'encrypted_data_length_' + encryptedPayload.length });
    
    const fullUrl = `${process.env.REACT_APP_BACKEND_SERVER}${endpoint}`;
    console.log('Full URL:', fullUrl);
    
    const response = await fetch(fullUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    });

    console.log('Response status:', response.status);
    console.log('Response headers:', Object.fromEntries(response.headers.entries()));

    if (!response.ok) {
      const errorBody = await response.text();
      console.error('API response error:', response.status, errorBody);
      
      // If encryption failed, try without encryption as fallback
      if (response.status === 400 && errorBody.includes('Invalid encrypted payload')) {
        console.log('Trying fallback without encryption...');
        const fallbackResponse = await fetch(fullUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(params)
        });
        
        if (fallbackResponse.ok) {
          const fallbackData = await fallbackResponse.json();
          console.log('Fallback API response received:', fallbackData);
          return fallbackData;
        }
      }
      
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorBody}`);
    }

    const responseData = await response.json();
    console.log('API response received:', responseData);
    return responseData;
  } catch (error) {
    console.error('API call error:', error);
    throw error;
  }
};

// Get price range statistics from backend
export const getPriceRangeStats = async () => {
  try {
    console.log("Fetching price range statistics...");
    const response = await apiCall("property/getPriceRangeStats", {});
    
    if (response && typeof response === 'object') {
      console.log("Price range stats received:", response);
      return response;
    } else {
      console.warn("Invalid price range stats response:", response);
      return {
        minPrice: 1,
        maxPrice: 10000,
        priceDistribution: Array(30).fill(0),
        totalListings: 0
      };
    }
  } catch (error) {
    console.error("Error fetching price range stats:", error);
    return {
      minPrice: 1,
      maxPrice: 10000,
      priceDistribution: Array(30).fill(0),
      totalListings: 0
    };
  }
};

// Get listing count for a specific price range
export const getListingsInPriceRange = async (minPrice, maxPrice) => {
  try {
    console.log(`Getting listings count for range: ${minPrice} - ${maxPrice}`);
    const response = await apiCall("property/getListingsInPriceRange", {
      minPrice,
      maxPrice
    });
    
    if (response && typeof response === 'object' && response.count !== undefined) {
      console.log(`Found ${response.count} listings in range ${minPrice} - ${maxPrice}`);
      return response.count;
    } else {
      console.warn("Invalid listings count response:", response);
      return 0;
    }
  } catch (error) {
    console.error("Error getting listings count:", error);
    return 0;
  }
};
